import { render, staticRenderFns } from "./PaymentsReport.vue?vue&type=template&id=b7977530&scoped=true&"
import script from "./PaymentsReport.vue?vue&type=script&lang=js&"
export * from "./PaymentsReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7977530",
  null
  
)

export default component.exports